import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Marque les balises meta statiques d'index.html (og:/twitter:/description) AVANT le
// montage de React : le composant SEO les supprimera au premier rendu pour éviter les
// doublons avec celles injectées par react-helmet-async (SPA, pas de SSR).
document.head.querySelectorAll("meta").forEach((el) => {
  const key = el.getAttribute("property") || el.getAttribute("name") || "";
  if (/^(og:|twitter:|description$)/.test(key)) el.setAttribute("data-static-seo", "1");
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
